
import { mapMutations, mapState } from 'vuex';

import Product from '@/components/shop/product.vue';
import LoadMore from '@/components/ui/loadMore.vue';
import EmptyState from '~/components/ui/emptyState.vue';
import { filterProducts } from '@/utils/filterProducts';

export default {
  name: 'MyWatchlist',

  components: {
    Product,
    LoadMore,
    EmptyState,
  },

  layout: 'cat',

  data() {
    return {
      page: 1,
      lastPage: null,
      perPage: 12,
      loading: false,
      noProducts: false,
      myWatchlistIds: [],
    };
  },

  computed: {
    ...mapState(['myFavorites', 'myWatchlist', 'user', 'products']),

    myProductsOnly() {
      return filterProducts(
        this.$store,
        this.products.filter((p) => this.myWatchlistIds.includes(p.sku))
      );
    },
  },

  async mounted() {
    if (this.user === null) {
      this.$router.push(this.localePath({ name: 'shop' }));
    }
    if (this.myWatchlist.length) {
      this.myWatchlistIds = this.myWatchlist.map((f) => f.sku);
      const { data, headers } = await this.$wc.products({
        perPage: this.perPage,
        page: this.page,
        sku: this.myWatchlistIds,
      });
      if (data && data.length) {
        this.setProducts(data);
        this.page++;
        if (headers['x-wp-totalpages']) {
          this.lastPage = parseInt(headers['x-wp-totalpages']);
        }
      }
    } else {
      // this.$router.push(this.localePath({ name: 'shop' }));
      this.noProducts = true;
    }
  },

  methods: {
    ...mapMutations(['setProducts']),

    async getProducts() {
      const { data, headers } = await this.$wc.products({
        perPage: this.perPage,
        page: this.page,
        sku: this.myWatchlistIds,
      });
      if (data && data.length) {
        this.setProducts(data);
        this.page++;
        if (headers['x-wp-totalpages']) {
          this.lastPage = parseInt(headers['x-wp-totalpages']);
        }
      }
    },
  },
};
